/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Image_Enabled_ToastInputs */



/**
* | output |
* | --- |
* | "Image compliance enabled." |
*
* @param {Compliance_Image_Enabled_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_image_enabled_toast = /** @type {((inputs?: Compliance_Image_Enabled_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Image_Enabled_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bild-Compliance aktiviert.")
	return /** @type {LocalizedString} */ ("Image compliance enabled.")
});